<ng-container>
  <automata-automation-replacement-chips
    label="AUTOMATIONS.COMMON.LIST"
    [dataService]="actionListsSelectorService"
    [formControl]="listOptionsControl"
    [isRequired]="true"
    [multiple]="true"
    [supportDataPassing]="false"
  ></automata-automation-replacement-chips>
</ng-container>
